import Dashbaord from './Dashboard';

export default Dashbaord;
